var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"app-main",class:[(_vm.tabbarShow ? ' appHomePage ' : ''),(_vm.back?' gray ':'')]},[_c('keep-alive',{attrs:{"include":_vm.includeList}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }